import App from 'app/app.js';

// This is Common Service we can use it for data sharing, custom validations.
function ConfirmSchoolService(
  JobStore,
  $window,
  SubjectStore,
  ShoppingCartStore,
  RouterService,
  CommonService,
  BlockService,
  GradeService,
  JobCleanUpService,
  RedirectionService,
  ErrorLogService,
  EventDataService,
  $rootScope
) {
  let confirmStudentInfoFormDrawer;
  let previousSelectedMasterSubjectId;

  this.onSubjectSelection = function (subject, selectedMasterEvent) {
    $rootScope.openCopyOrderModalOnSubjectLoad = true;
    SubjectStore.setFromConfirmExistingStudent(false);
    // The master event in the argument for mobile, (For Web) this.eventName when any event selected ,
    //    subject.selectedEvent for the Most Recent Event
    this.selectedSubject = subject;
    SubjectStore.setSelectedSubject(this.selectedSubject);
    //To check whether the current event  and selected  event are same, it doesn't make duplicate call for JobStore.loadJob()
    const isCurrentEventSameAsSelectedEvent = this.isCurrentEventSameAsSelectedMasterEvent(
      this.selectedSubject,
      selectedMasterEvent
    );
    if (
      this.selectedSubject.currentEvent &&
      this.selectedSubject.currentEvent.event &&
      isCurrentEventSameAsSelectedEvent
    ) {
      this.loadCurrentJobAndOrder(selectedMasterEvent);
    } else {
      SubjectStore.attachMasterEventsToSubject(this.selectedSubject).then(
        function () {
          this.onEventsLoaded(selectedMasterEvent);
        }.bind(this)
      );
    }
  };

  this.isCurrentEventSameAsSelectedMasterEvent = function (subject, selectedMasterEvent) {
    const currentEventJobNumber =
      this.selectedSubject.currentEvent &&
      this.selectedSubject.currentEvent.event &&
      this.selectedSubject.currentEvent.event.jobNumber;
    const selectedEventJobNumber =
      selectedMasterEvent && selectedMasterEvent.eventType && selectedMasterEvent.eventType.jobNumber;

    if (currentEventJobNumber && selectedEventJobNumber) {
      return currentEventJobNumber === selectedEventJobNumber;
    }

    return currentEventJobNumber && !subject.masterEvents;
  };

  this.loadCurrentJobAndOrder = function (masterEvent) {
    const orderIndex = ShoppingCartStore.getSubjectIndex(this.selectedSubject.subjectOrderId);
    if (orderIndex > -1) {
      if (this.selectedSubject.subjectOrderId !== ShoppingCartStore.getCurrentSubject().id) {
        ShoppingCartStore.setCurrentSubject(orderIndex);
      }
      this.goToNextRoute();
    } else {
      this.loadJob(this.selectedSubject, masterEvent);
    }
  };

  this.loadJob = function (subjects, masterEvent) {
    if (!JobCleanUpService.cleanUpAndCanAddMoreJobs()) {
      return;
    }
    const specOrderFlow = false;
    BlockService.blockUI();
    let eventData;
    if (subjects.masterEvents) {
      eventData = this.formatEventDataFromSubject(subjects, masterEvent);
    } else {
      eventData = this.formatEventDataFromSubjectForSingleEvent(subjects);
    }
    const isGroupOnlyCaptureSession =
      masterEvent && masterEvent.subjectInfo && masterEvent.subjectInfo.isGroupOnlyCaptureSession;
    this.jobLoadFailed = false;
    // TODO: Jobload failure handling, not defined by business as what to happen if jobload fails.
    JobStore.loadJob(eventData, specOrderFlow, true, 'LT')
      .then(
        function (data) {
          if (!data || (!!data.data && !data.data.success) || !JobStore.isJobLoaded()) {
            this.jobLoadFailed = true;
            return;
          }

          const subject = ShoppingCartStore.getCurrentSubject();

          subject.subjectFirstName = eventData.subjectFirstName;
          subject.subjectLastName = eventData.subjectLastName;
          subject.subjectRelationship = eventData.subjectRelationship;
          subject.subjectDetailsDeferred = this.selectedSubject.subjectDetailsDeferred;
          subject.subjectGrade = this.selectedSubject.subjectGrade;
          subject.subjectTeacherName = this.selectedSubject.subjectTeacherName;
          subject.dontKnowTeacherName = this.selectedSubject.dontKnowTeacherName;
          subject.studentId = eventData.studentId;
          subject.masterSubjectId = this.selectedSubject.masterSubjectId;
          subject.subjectAccountConfirmed = false;
          subject.ltMasterSubjectUuid = this.selectedSubject.ltMasterSubjectUuid;
          subject.allowPersonalizationNamePrefill = Boolean(
            subject.subjectFirstName && !SubjectStore.isGeneratedFirstNamePlaceholder(subject.subjectFirstName)
          );

          const currentJob = JobStore.getJob();
          if (currentJob && currentJob.lifetouchId) {
            subject.lifetouchId = currentJob.lifetouchId;
          }

          if (!isGroupOnlyCaptureSession && this.showConfirmStudentFormDrawer(eventData)) {
            return;
          }

          subjects.subjectOrderId = subject.id;
          ShoppingCartStore.confirmSubjectAccount();
          SubjectStore.updateSubjectByJob(currentJob, subject);
          SubjectStore.updateStorage();
          this.goToNextRoute();
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.unblockUI();
      });
  };
  this.goToNextRoute = function () {
    RedirectionService.routeNext({ skipMyProofs: SubjectStore.isMasterSubjectProfileXrefStatusVerified() });
  };

  this.formatEventDataFromSubject = function (subject, masterEvent) {
    if (masterEvent?.subjectInfo?.portraitIdAccessCode != null) {
      const portraitIdAccessCode = masterEvent.subjectInfo.portraitIdAccessCode;
      return {
        ...EventDataService.parseAccessCredential(portraitIdAccessCode),
        subjectFirstName: subject.subjectFirstName,
        subjectLastName: subject.subjectLastName,
        subjectRelationship: subject.subjectRelationship,
        subjectGrade: subject.currentGrade || masterEvent.subjectInfo.grade,
        studentId: subject.studentId
      };
    } else {
      return {
        pictureDayId: masterEvent.eventType.jobNumber,
        subjectFirstName: subject.subjectFirstName,
        subjectLastName: subject.subjectLastName,
        subjectRelationship: subject.subjectRelationship,
        subjectGrade: subject.currentGrade || masterEvent.subjectInfo.subjectGrade,
        studentId: subject.studentId
      };
    }
  };

  this.formatEventDataFromSubjectForSingleEvent = function (subject) {
    const hasPortraitId = subject.currentEvent && subject.currentEvent.portraitId && subject.currentEvent.accessCode;
    const eventData = {
      studentId: subject.studentId,
      subjectGrade: subject.currentGrade || subject.currentEvent.subjectGrade,
      subjectRelationship: subject.subjectRelationship,
      subjectLastName: subject.subjectLastName,
      subjectFirstName: subject.subjectFirstName
    };

    if (hasPortraitId) {
      return {
        ...eventData,
        portraitId: subject.currentEvent.portraitId,
        accessCode: subject.currentEvent.accessCode
      };
    }
    return {
      ...eventData,
      pictureDayId: subject.currentEvent.event.jobNumber
    };
  };

  this.onEventsLoaded = function (masterEvent) {
    if (this.selectedSubject.masterEvents?.length > 0) {
      this.loadJobFromEvent(masterEvent);
    }
  };

  this.loadJobFromEvent = function (eventData, addSubjectByJob) {
    if (!JobCleanUpService.cleanUpAndCanAddMoreJobs()) {
      return;
    }
    this.selectedSubject = SubjectStore.getSelectedSubject();
    const specOrderFlow = false;
    BlockService.blockUI();
    const isGroupOnlyCaptureSession = eventData.subjectInfo.isGroupOnlyCaptureSession;
    eventData = this.formatEventDataFromEvent(eventData);
    this.jobLoadFailed = false;

    //TODO: Jobload failure handling, not defined by business as what to happen if jobload fails.
    JobStore.loadJob(eventData, specOrderFlow, true, 'LT')
      .then(
        function (data) {
          if (!data || (data.data && !data.data.success) || !JobStore.isJobLoaded()) {
            this.jobLoadFailed = true;
            return;
          }
          const subject = ShoppingCartStore.getCurrentSubject();
          subject.subjectFirstName = eventData.subjectFirstName;
          subject.subjectLastName = eventData.subjectLastName;
          subject.subjectRelationship = eventData.subjectRelationship;
          subject.subjectGrade =
            eventData.subjectGrade && JobStore.isUnderclass() ? eventData.subjectGrade : GradeService.getNoGrade();
          if (!addSubjectByJob) {
            subject.studentId = this.selectedSubject.studentId;
            subject.masterSubjectId = this.selectedSubject.masterSubjectId;
            subject.ltMasterSubjectUuid = this.selectedSubject.ltMasterSubjectUuid;
          }
          subject.subjectAccountConfirmed = false;
          subject.allowPersonalizationNamePrefill = Boolean(
            subject.subjectFirstName && !SubjectStore.isGeneratedFirstNamePlaceholder(subject.subjectFirstName)
          );
          const currentJob = JobStore.getJob();
          if (currentJob && currentJob.lifetouchId) {
            subject.lifetouchId = currentJob.lifetouchId;
          }
          this.selectedSubject.subjectOrderId = subject.id;
          if (!isGroupOnlyCaptureSession && this.showConfirmStudentFormDrawer(eventData)) {
            return;
          }
          if (addSubjectByJob) {
            SubjectStore.addOrUpdateSubjectByJob(currentJob, subject);
          } else {
            SubjectStore.updateSubjectByJob(currentJob, subject);
          }
          this.confirmSubjectAndContinue(eventData);
          SubjectStore.updateStorage();
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.unblockUI();
      });
  };

  this.showConfirmStudentFormDrawer = function (event) {
    if (CommonService.gradeOrTeacherNameRequired(event)) {
      this.selectedEventInfo = event;
      $rootScope.$broadcast('confirmStudentFormData', event);
      confirmStudentInfoFormDrawer.open();
      $window.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
    }
    return false;
  };

  this.formatEventDataFromEvent = function (event) {
    return EventDataService.formatEventData(event, this.selectedSubject, this.subjectRelationship);
  };

  this.confirmSubjectAndContinue = function (eventData) {
    if (RouterService.isSflyMobile()) {
      try {
        CommonService.sendPictureDayToApp(eventData);
      } catch (error) {
        error.message = 'Error while attempting to send Picture Day to SFLY_MOBILE: ' + error.message;
        ErrorLogService(error);
      }
    }
    ShoppingCartStore.confirmSubjectAccount();
    this.goToNextRoute();
  };

  this.setConfirmStudentInfoFormDrawer = function (drawer) {
    confirmStudentInfoFormDrawer = drawer;
  };
}
App.service('ConfirmSchoolService', [
  'JobStore',
  '$window',
  'SubjectStore',
  'ShoppingCartStore',
  'RouterService',
  'CommonService',
  'BlockService',
  'GradeService',
  'JobCleanUpService',
  'RedirectionService',
  'ErrorLogService',
  'EventDataService',
  '$rootScope',
  ConfirmSchoolService
]);
